module.exports = __webpack_public_path__ + "947b87451887dc55e3e0beaf09eca155.png";